let MetaDataService = {
    generateRandomString() {
        const packageId = [...Array(8)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
        return packageId;
    },
};

export default MetaDataService;
